import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { DesktopNav } from "./BottomNav";
import { useAuth } from "../context/AuthContext";
import { LangToggle, useT } from "../i18n";

export const TopBar = ({ back = true, onBack, right = null, compact = false }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useT();
  return (
    <header className="sticky top-0 z-30 bg-rox-black/90 backdrop-blur-md lg:border-b lg:border-rox-line">
      <div className="flex h-14 items-center justify-between px-4 lg:hidden">
        <div className="w-10">
          {back && (
            <button data-testid="back-button" onClick={onBack || (() => navigate(-1))} className="-ml-2 flex h-10 w-10 items-center justify-center text-rox-off transition-colors hover:text-rox-orange" aria-label={t("a_back")}>
              <ArrowLeft size={22} strokeWidth={2.2} />
            </button>
          )}
        </div>
        <Logo className="text-xl" to={user ? "/recherche" : "/"} />
        <div className={`flex justify-end ${compact && !right ? "w-auto" : "w-10"}`}>{compact && !right ? <LangToggle /> : right}</div>
      </div>
      <div className="hidden h-16 items-center justify-between px-8 lg:flex">
        <div className="flex items-center gap-8">
          <Logo className="text-2xl" to={user ? "/recherche" : "/"} />
          {user && !compact && <DesktopNav />}
        </div>
        <div className="flex items-center gap-4">
          <LangToggle />
          {right}
        </div>
      </div>
    </header>
  );
};
